// extracted by mini-css-extract-plugin
module.exports = {"brandsPage":"BrandsPage_brandsPage__nqZQ2","noTab":"BrandsPage_noTab__3KgB4"};